module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v(_vm._s(_vm.email.subject))]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users background-1-20 color-2-100",
    attrs: {
      "to": {
        name: 'email-logs'
      }
    }
  }, [_vm._v("\n        Back to email logs\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('p', [_c('strong', [_vm._v("Subject")]), _vm._v(": " + _vm._s(_vm.email.subject ? _vm.email.subject : 'n/a'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Status")]), _vm._v(": " + _vm._s(_vm.email.status ? _vm.email.status.label : 'n/a'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mail to")]), _vm._v(": " + _vm._s(_vm.email.mail_to ? _vm.email.mail_to : 'n/a'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Type")]), _vm._v(": " + _vm._s(_vm.email.type ? _vm.email.type.label : 'n/a'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Date and time")]), _vm._v(": " + _vm._s(_vm.email.created ? _vm.convertDate(_vm.email.created) : 'n/a'))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "emailBody"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18c3c9e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/EmailSingle.vue
// module id = 950
// module chunks = 0